'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = ['beforeChange', 'afterChange', 'imageLoadComplete', 'resize', 'gettingData', 'mouseUsed', 'initialZoomIn', 'initialZoomInEnd', 'initialZoomOut', 'initialZoomOutEnd', 'parseVerticalMargin', 'close', 'unbindEvents', 'destroy', 'updateScrollOffset', 'preventDragEvent', 'shareLinkClick'];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-photoswipe/lib/events.js
// module id = 98
// module chunks = 0